module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/actualgame.json
// module id = 316
// module chunks = 115196734528148